export enum DisclaimerTypes {
	Info = 'info',
	Alert = 'alert',
	Warning = 'warning',
	Danger = 'danger',
	Positive = 'positive'
}
